import { Field } from "formik";
import React from "react";
import { Form } from "react-bootstrap";

const FormikDropdown = ({
  as,
  md,
  size,
  controlId,
  label,
  name,
  className,
  placeholder,
  required,
  options,
  optionVal,
}) => {
  return (
    <>
      <Field
        name={name}
        render={({ field, form }) => {
          const isValid = !form.errors[field.name];
          const isInvalid = form.touched[field.name] && !isValid;
          return (
            <Form.Group
              md={md}
              controlId={controlId}
              className={`form-group ${className}`}
            >
              <Form.Label>
                {label} {required && <span className="text-danger">*</span>}
              </Form.Label>
              <Form.Control
                {...field}
                as="select"
                className="form-select"
                placeholder={placeholder || label}
                isInvalid={isInvalid}
                feedback={form.errors[field.name]}
                size={size}
                value={field.value}
                onChange={(e) => {
                  form.setFieldValue(name, e.target.value);
                }}
              >
                {placeholder && (
                  <option key="default" value={""}>
                    {placeholder}
                  </option>
                )}
                {options.map((option, index) => {
                  const value = optionVal ? optionVal : "value";
                  return (
                    <option key={index} value={option[value]}>
                      {option.name}
                    </option>
                  );
                })}
              </Form.Control>

              <Form.Control.Feedback type="invalid">
                {form.errors[field.name]}
              </Form.Control.Feedback>
            </Form.Group>
          );
        }}
      />{" "}
    </>
  );
};

export default FormikDropdown;
